import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { OfferSelector } from '../offers/OfferSelector';
import { OfferId } from '../offers/offerData';
import { PurchaseButton } from '../offers/PurchaseButton';
import { Countdown } from '../ui/Countdown';
import { Section } from '../ui/Section';
type Props = {
  selectedOffer: OfferId;
  onSelectOffer: (offer: OfferId) => void;
};
export function FinalCta({
  selectedOffer,
  onSelectOffer
}: Props) {
  return <Section className="bg-ink text-cream" data-id="element-85" data-mp="1ipwuachndwbe">
      <div className="mx-auto max-w-3xl text-center" data-id="element-86" data-mp="1iqodsoxz03lb">
        <h2 className="font-display text-3xl font-semibold leading-tight sm:text-5xl" data-id="element-87" data-mp="14q3wjx7peftx">No dejes pasar esta oportunidad</h2>
        <p className="mt-2 text-[10px] uppercase tracking-luxe text-rose sm:mt-4 sm:text-sm" data-id="element-88" data-mp="19of3o06m6c8g">Termina en</p>
        <div className="mt-3 sm:mt-5" data-id="element-89" data-mp="2z3v9b5lbxftl"><Countdown variant="dark" data-id="element-90" data-mp="2z4odpzwtft8k" /></div>
      </div>

      <div className="mx-auto mt-7 max-w-xl sm:mt-10" data-id="element-91" data-mp="343rhlh127tey">
        <OfferSelector selectedOffer={selectedOffer} onSelect={onSelectOffer} tone="dark" data-id="element-92" data-mp="3415afii2zfx9" />
        <PurchaseButton selectedOffer={selectedOffer} className="mt-4 bg-rose text-white shadow-rose/30 hover:bg-rose/90 sm:mt-5" data-id="element-93" data-mp="27ab4kubabkx" />
      </div>

      <div className="mx-auto mt-5 flex max-w-2xl flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] text-cream/70 sm:mt-8 sm:gap-x-6 sm:gap-y-2 sm:text-xs" data-id="element-94" data-mp="b16r1hwvurrw">
        <span className="flex items-center gap-1" data-id="element-95" data-mp="727hfk07i6u4"><LockIcon className="h-3 w-3 text-rose sm:h-4 sm:w-4" data-id="element-96" data-mp="3feva0mxnamh1" />Pago seguro</span>
        <span className="flex items-center gap-1" data-id="element-97" data-mp="3ah3gjohcqsaq"><ZapIcon className="h-3 w-3 text-rose sm:h-4 sm:w-4" data-id="element-98" data-mp="3ai4rlsydbesg" />Acceso en 5 min</span>
        <span className="flex items-center gap-1" data-id="element-99" data-mp="3ohebp3pp2t1p"><ShieldCheckIcon className="h-3 w-3 text-rose sm:h-4 sm:w-4" data-id="element-100" data-mp="3odyr5ld94rsw" />Garantía 7 días</span>
        <span data-id="element-101" data-mp="3jjcrugkg2pp6">💳 Mercado Pago</span>
      </div>
    </Section>;
}